import { ProductSupplierOrderChannel } from '@gooduncles/gu-app-schema';

export const orderStatusKr: Record<number, string> = {
  /** SUBMITTED */
  10: '⚪️ 수락대기',
  /** ACCEPTED */
  20: '🟡 주문수락',
  /** DELIVERED */
  50: '🟢 배송완료',
  /** CANCELED */
  60: '⚫️ 주문취소',
  /** REJECTED */
  70: '🔴 주문거절',
};

export const orderStatusEn = {
  10: 'submitted',
  20: 'accepted',
  50: 'delivered',
  60: 'canceled',
  70: 'rejected',
};

export const editOrderErrors = {
  signup: '회원 가입이 필요합니다. 회원가입 바로가기',
  onEdit: '수정을 누른 후 변경할 수 있습니다.',
};

/**
 * 정산이 완료된 주문인지를 확인하는 테이블
 * 수정하는 당시의 요일이 배열의 index에 해당하고,
 * 주문 날짜의 요일이 해당 value에 해당하는 요일이라면 미정산 단계로 수정이 가능하다.
 *
 */
export const settlementDayTable = [
  // 현재 요일 - 수정 가능한 요일
  // 일 - 목, 금, 토, 일
  [4, 5, 6, 0],
  // 월 - 목, 금, 토, 일, 월
  [0, 1, 4, 5, 6],
  // 화 - 월, 화
  [1, 2],
  // 수 - 월, 화, 수
  [1, 2, 3],
  // 목 - 월, 화, 수, 목
  [1, 2, 3, 4],
  // 금 - 목, 금
  [4, 5],
  // 토 - 목, 금, 토
  [4, 5, 6],
];

/** 패킹시트와 거래명세서의 상품 정렬순서 */
export const packingOrder = ['bag', 'box', 'others'];
/** 패킹시트와 거래명세서의 상품 정렬순서 */
export const storageOrder = ['room', 'refrigerator', 'freezer', null];

export const purchaseMethodToKr: Record<string, string> = {
  kakaotalk: '카톡',
  sms: '문자',
  call: '전화',
  api: '전산',
  visit: '방문',
  office: '사무실',
  etc: '기타',
};

export const purchaseBundleToKr: Record<string, string> = {
  max: '최대 묶음',
  all: '전체',
  store: '매장별',
  storeGroup: '매장별 수량 묶음',
};

export const orderChannelOptions = Object.values(ProductSupplierOrderChannel).map((value) => ({
  value,
  label: {
    [ProductSupplierOrderChannel.KAKAOTALK]: '카카오톡',
    [ProductSupplierOrderChannel.SMS]: '문자메시지',
    [ProductSupplierOrderChannel.CALL]: '전화',
    [ProductSupplierOrderChannel.API]: 'API 연동',
    [ProductSupplierOrderChannel.VISIT]: '방문',
    [ProductSupplierOrderChannel.OFFICE]: '사무실',
    [ProductSupplierOrderChannel.ETC]: '기타',
  }[value],
}));
